<template>
  <div class="edit-recipe wrapper">

    <div v-if="!loggedIn" class="text-center">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Please Log in</h5>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="loggedIn" >
      <div class="col-12">
        <recipes-list :include-private="true">My brews</recipes-list>
      </div>
    </div>
  </div>
</template>

<script>
  import RecipesList from "../components/RecipesList";
  import { EventBus } from '../lib/event-bus.js';

  export default {
    name: "recipes",
    components: {
        RecipesList,
    },
    data() {
      return {
        recipes: undefined,
        errors: null,
        loading: true,
        loggedIn: false,
      };
    },
    beforeMount() {
      this.loggedIn = !!localStorage.username;
      EventBus.$on('logged-in', val => { this.loggedIn = val; });
    },
  };
</script>

<style scoped lang="scss">

</style>
